import React from 'react'
import { PaymentBadges } from '@/components/PaymentBadges'

export type PaymentBadgesBlockProps = {
  alignment?: 'left' | 'center' | 'right'
  marginTop?: boolean
  blockType: 'paymentBadges'
}

export const PaymentBadgesBlock: React.FC<PaymentBadgesBlockProps> = ({
  alignment = 'left',
  marginTop = true,
}) => {
  const alignmentClasses = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end',
  }

  return (
    <div className={`flex ${alignmentClasses[alignment]} ${marginTop ? 'mt-4' : ''}`}>
      <PaymentBadges />
    </div>
  )
}